import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/Header/Header";
import SettingNotification from "../../components/SettingNotification/SettingNotification";
import SettingInvestment from "../../components/SettingInvestment/SettingInvestment";
import { useLocation, useNavigate } from "react-router";
import SettingFamilyAccess from "../../components/SettingFamilyAccess/SettingFamilyAccess";
import ManageDevices from "../../components/ManageDevices/ManageDevices";
import LiaisonOfficerAccess from "../../components/LiaisonOfficerAccesss/LiaisonOfficerAccess";
import SideBarList from "../../components/SideBarList/SideBarList";
import { Observer, observer } from "mobx-react";
import LoadingScreen from "../../components/LoadingScreen/LoadingScreen";
import ArrowButton from "../../components/ArrowButton";
import {
  getBlobToBase64,
  getDecodedToken,
  getFileSize,
} from "../../utils/functions";
import imageIcon from "../../assets/images/svg/imageIcon.svg";
import defaultImgForLiasionAccess from "../../assets/images/svg/defaultImgForLiasionAccess.svg";
import LOProfileSelected from "../../assets/images/svg/LOprofileSelected.svg";
import AuthStore from "../../store/AuthStore";
import SettingsStore from "../../store/SettingsStore";
import ProfileStore2 from "../../store/ProfileStore2";
// import manageDeviceSelected from "../../assets/images/svg/manageDeviceSelected.svg";
// import investment_with_selected from "../../assets/images/svg/investment_with_selected.svg";
import reportSinceActive from "../../assets/images/svg/reportSinceActive.svg";
import liaisonSetting from "../../assets/images/svg/liaisonSetting.svg";
import investmentHeldTitle from "../../assets/images/svg/investmentHeldTitle.svg";
import manageDeviceTitle from "../../assets/images/svg/manageDeviceTitle.svg";
import settingFamily from "../../assets/images/svg/settingFamily.svg";
import UserStore from "../../store/UserStore";
import { useLayoutEffect } from "react";
import ReportType from "../../components/ReportType/ReportType";
import PageTitle from "../../components/PageTitle/PageTitle";
import PageHeading from "../../components/PageHeading/PageHeading";
import { familyOfficeTeamNameText } from "../../utils/constants";

const Settings = observer(() => {
  const [selectedSet, setSelectedSet] = useState("");
  const location = useLocation();
  const [uploadMessage, setUploadMessage] = useState({
    message: "",
    isError: false,
  });
  const [isUploadSuccess, setIsUploadSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showRemoveBtn, setshowRemoveBtn] = useState(false);
  const navigate = useNavigate();

  const userHydrated = UserStore.isHydrated;
  const settingsHydrated = SettingsStore.isHydrated;

  const AddImageModalContent = observer(
    ({
      uploadMessage,
      setUploadMessage,
      handleCancel,
      isUploadSuccess,
      setIsUploadSuccess,
      location,
    }) => {
      const fileRef = useRef();
      const uploadFile = (fileVar) => {
        const file = getSelectedFile(fileVar);
        const validation = validateFile(file);
        switch (validation) {
          case "file size error":
            setUploadMessage({
              message: "File size larger than 10 MB",
              isError: true,
            });
            SettingsStore.setTempProfile(null);
            break;
          case "file type error":
            setUploadMessage({
              message: "Only JPEG and PNG image formats are supported",
              isError: true,
            });
            SettingsStore.setTempProfile(null);
            break;
          case "valid file":
            setUploadMessage({
              message: "",
              isError: false,
            });
            SettingsStore.setTempProfile(file);
            setshowRemoveBtn(true);
            break;
          default:
            break;
        }
      };

      const validateFile = (file) => {
        const allowedFileExtention = [".png", ".jpeg", ".jpg"];
        const fileExtention = file?.name.substring(file?.name.lastIndexOf("."));
        const isFileSizevalid = file?.exactSize < 10485760;
        const isFileTypeValid = allowedFileExtention.includes(
          fileExtention.toLowerCase(),
        );
        if (!isFileSizevalid) {
          return "file size error";
        }
        if (!isFileTypeValid) {
          return "file type error";
        }
        if (isFileSizevalid && isFileTypeValid) {
          return "valid file";
        }
      };

      const getSelectedFile = (file) => {
        if (file) {
          const fileSrc = URL.createObjectURL(file);
          return {
            name: file.name,
            size: getFileSize(file.size),
            exactSize: file.size,
            type: file.type,
            src: fileSrc,
            file: file,
          };
        } else {
          return null;
        }
      };

      const handleFileClick = () => {
        if (!SettingsStore.tempProfileForUpdate) {
          fileRef.current.click();
        }
      };

      const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const dt = e.dataTransfer;
        const file = dt.files[0];
        uploadFile(file);
      };

      const handleInputChange = (e) => {
        e.preventDefault();
        const _file = e.target.files[0];
        uploadFile(_file);
      };

      const stopDefault = (e) => {
        e.preventDefault();
        e.stopPropagation();
      };

      const getImageType = (type) => {
        switch (type) {
          case "image/png":
            return "PNG";
          case "image/jpeg":
            return "JPEG";
          case "image/jpg":
            return "JPG";
          default:
            return "";
        }
      };

      const handleUpload = () => {
        if (SettingsStore.tempProfileForUpdate) {
          setshowRemoveBtn(false);
          ProfileStore2.uploadProfile2(
            SettingsStore.tempProfileForUpdate,
            SettingsStore.liaisonOfficerData.profile.user_id,
            {
              onSucess: (data) => {
                const imageArr = {};
                SettingsStore.getImageFromAPI({
                  path: data.url,
                  onSuccess: (imageBlob) => {
                    getBlobToBase64(imageBlob).then((url) => {
                      let resImage = url;
                      imageArr[
                        SettingsStore.liaisonOfficerData.profile.user_id
                      ] = resImage;
                      SettingsStore.liaisonOfficerImages = {
                        ...SettingsStore.liaisonOfficerImages,
                        ...imageArr,
                      };
                    });
                    SettingsStore.liaisonOfficerData = {
                      ...SettingsStore.liaisonOfficerData,
                      profile: {
                        ...SettingsStore.liaisonOfficerData.profile,
                        profile_pic: data.url,
                      },
                    };
                  },
                });

                setUploadMessage({
                  message:
                    "Family office team profile picture uploaded successfully",
                  isError: false,
                });
                setTimeout(() => {
                  handleSave();
                }, 2000);
              },
              onFail: (error) => {
                setshowRemoveBtn(true);
                setUploadMessage({
                  message: "Error While Uploading Profile Photo",
                  isError: true,
                });
              },
            },
          );
        }
        setIsUploadSuccess(true);
      };

      const handleSave = () => {
        SettingsStore.updateProfile(SettingsStore.tempProfileForUpdate);
        SettingsStore.setTempProfile(null);
        setUploadMessage({
          message: "",
          isError: false,
        });
        setIsUploadSuccess(false);
      };

      const handleRemove = () => {
        SettingsStore.setTempProfile(null);
        setUploadMessage({
          message: "",
          isError: false,
        });
        setIsUploadSuccess(false);
      };

      const getContentForDashedArea = () => {
        if (SettingsStore.tempProfileForUpdate) {
          return (
            <div className="selected_image_container">
              <img src={imageIcon} alt="icon" />
              <p className="file_details">
                {SettingsStore.tempProfileForUpdate?.name ||
                  SettingsStore.profile?.name}{" "}
                -{" "}
                {SettingsStore.tempProfileForUpdate?.size ||
                  SettingsStore.profile?.size}{" "}
                {getImageType(
                  SettingsStore.tempProfileForUpdate?.type ||
                    SettingsStore.profile?.type,
                )}{" "}
                format
              </p>
              <button className="remove_btn" onClick={handleRemove}>
                {showRemoveBtn && "Remove"}
              </button>
            </div>
          );
        } else {
          return (
            <div
              onDragEnter={stopDefault}
              onDragOver={stopDefault}
              onDrop={handleDrop}
              className="drap_and_drop_container_border"
            >
              <div className="drap_and_drop_container">
                <p className="drag_drop_text">Drag and drop your image </p>
                <p className="file_support_text">
                  Files Supported: JPEG, PNG and Maximum Size: 10 MB
                </p>
              </div>
              <input
                onChange={handleInputChange}
                type="file"
                accept="image/png, image/jpeg , image/jpg"
                style={{ display: "none" }}
                ref={fileRef}
              />
            </div>
          );
        }
      };

      const checkDisabled = () => {
        return !SettingsStore.tempProfileForUpdate;
      };

      const getCurrentProfile = () => {
        return SettingsStore.tempProfileForUpdate
          ? SettingsStore.tempProfileForUpdate.src
          : SettingsStore.liaisonOfficerData?.profile?.profile_pic
            ? SettingsStore.liaisonOfficerImages?.[
                SettingsStore.liaisonOfficerData?.profile?.user_id
              ]
            : defaultImgForLiasionAccess;
      };

      return (
        <>
          <div className="settings_lo_update investments_held_with">
            <div className="investments_held_with_heading">
              <div className="investments_held_with_heading_img_wrapper">
                <img
                  className="investments_held_with_heading_img"
                  src={LOProfileSelected}
                  alt="investment_icon"
                />
              </div>
              <p className="investments_held_with_heading_text">
                Change Profile Photo
              </p>
            </div>
            <div className="investments_held_with_sub_heading">
              Change/update your profile picture
            </div>
            <div
              className="add_image_container"
              style={{ paddingBottom: "20px" }}
            >
              <div className="settings_update_lo_profile_border">
                <div className="default_image_name_wrapper">
                  <p
                    className={`message ${
                      uploadMessage.isError ? "red_text" : ""
                    }`}
                  >
                    {uploadMessage.message}
                  </p>
                  <img
                    onClick={handleFileClick}
                    src={getCurrentProfile()}
                    alt="default"
                    className={`${
                      SettingsStore.profile ? "" : "cursor_pointer"
                    } clickable`}
                  />
                  <p className="user_name">{familyOfficeTeamNameText}</p>
                </div>
                {getContentForDashedArea()}
              </div>
              <div className="bottom_button_container">
                <ArrowButton
                  type="next"
                  label={
                    uploadMessage.message ===
                    "Family office team profile picture uploaded successfully"
                      ? "Save"
                      : "Save"
                  }
                  disabled={checkDisabled()}
                  onClick={handleUpload}
                />
              </div>
            </div>
          </div>
        </>
      );
    },
  );

  const handleWealth = (name) => {
    if (name === "nuvama") {
      switch (SettingsStore.investmentHeldWith) {
        case "0":
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("2");
          break;
        case null:
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("2");
          break;
        case "1":
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("2");
          break;
        case "2":
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("0");
          break;
        default:
          break;
      }
    } else {
      switch (SettingsStore.investmentHeldWith) {
        case "0":
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("1");
          break;
        case null:
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("1");
          break;
        case "1":
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("0");
          break;
        case "2":
          window.scrollTo(0, 0);
          AuthStore.updateLoadingFullScreen(true);
          SettingsStore.callInvestmentsHeldWith("1");
          break;
        default:
          break;
      }
    }
  };

  useEffect(() => {
    if (UserStore.isHydrated && SettingsStore.isHydrated) {
      setLoading(false);
      if (location?.state?.from) {
        setSelectedSet(location?.state?.from);
      } else if (getDecodedToken()?.user_type === "customer") {
        if (UserStore.userData?.isprimary) {
          setSelectedSet("family_member_access");
        } else {
          setSelectedSet("manage_devices");
        }
      } else if (getDecodedToken()?.user_type === "manager") {
        setSelectedSet("change_profile_photo");
      }
    }
  }, [
    location?.state,
    userHydrated,
    settingsHydrated,
    //UserStore.isHydrated,
    // SettingsStore.isHydrated
  ]);

  const handleCancel = () => {
    setUploadMessage({
      message: "",
      isError: false,
    });
    SettingsStore.setTempProfile(null);
    setIsUploadSuccess(false);
  };

  const getSettingsTabContent = () => {
    switch (selectedSet) {
      case "family_member_access":
        return <SettingFamilyAccess />;
      case "liaison_office_access":
        return <LiaisonOfficerAccess />;

      case "manage_devices":
        return <ManageDevices />;

      case "notification_settings":
        return <SettingNotification />;

      case "investments_held_with":
        return <SettingInvestment handleWealth={handleWealth} />;
      case "report_type":
        return <ReportType />;
      case "change_profile_photo":
        return (
          <AddImageModalContent
            uploadMessage={uploadMessage}
            setUploadMessage={setUploadMessage}
            handleCancel={handleCancel}
            isUploadSuccess={isUploadSuccess}
            setIsUploadSuccess={setIsUploadSuccess}
            location={location}
          />
        );
      default:
        return <SettingNotification />;
    }
  };

  useEffect(() => {
    if (UserStore.isHydrated && SettingsStore.isHydrated) {
      window.scrollTo(0, 0);
      AuthStore.updateLoadingFullScreen(true);
      //   ProfileStore2.getProfileImage(UserStore.userData?.profile_pic);
      SettingsStore.populateSettingsData();
    }
  }, [
    userHydrated,
    settingsHydrated,
    //  UserStore.isHydrated, SettingsStore.isHydrated
  ]);

  useLayoutEffect(() => {
    AuthStore.updateLoadingFullScreen(true);
  }, []);

  if (getDecodedToken()?.user_type === "employee") {
    navigate("/not-found");
  } else
    return (
      <Observer>
        {() => (
          <div>
            <PageTitle title={"Settings"} />
            {loading ||
            AuthStore.isLoadingFullScreen ||
            AuthStore.isLoadingForSettingsLO ||
            (!UserStore.isHydrated && !SettingsStore.isHydrated) ? (
              <LoadingScreen />
            ) : (
              <>
                <Header type="settings" />{" "}
                <div className="settings_fixed_header_custom">
                  <div className="left-container-div">
                    <PageHeading headingClass="head" headingText="Settings" />
                    <div className="options_div">
                      <SideBarList
                        setList={SettingsStore.settingsOptionsArr}
                        selectedSet={selectedSet}
                        setSelectedSet={(data) => {
                          setSelectedSet(data);
                          navigate("/settings", { state: { from: data } });
                        }}
                        styleClass={{
                          selectedText: "selcted_text_tab",
                          notSelectedTab: "not_selected_text_tab",
                        }}
                        imgWidth={{
                          width: "21px",
                          height: "21px",
                        }}
                      />
                    </div>
                  </div>
                  <div class="vl"></div>
                  <div className="right-container-div">
                    <div
                      class="sticky-div"
                      style={
                        getDecodedToken()?.user_type === "manager"
                          ? { paddingBottom: "0px" }
                          : {}
                      }
                    >
                      {getDecodedToken()?.user_type !== "manager" && (
                        <>
                          <div className="manage_device_header">
                            <div className="mange_device_image_wrapper">
                              <img
                                src={
                                  selectedSet === "manage_devices"
                                    ? manageDeviceTitle
                                    : selectedSet === "investments_held_with"
                                      ? investmentHeldTitle
                                      : selectedSet === "liaison_office_access"
                                        ? liaisonSetting
                                        : selectedSet === "family_member_access"
                                          ? settingFamily
                                          : selectedSet === "report_type"
                                            ? reportSinceActive
                                            : ""
                                }
                                style={
                                  selectedSet === "report_type"
                                    ? { height: "50px" }
                                    : { display: "block" }
                                }
                                alt=""
                              />
                            </div>
                            <p className="manage_device_heading_text">
                              {selectedSet === "manage_devices"
                                ? "Managed Devices"
                                : selectedSet === "investments_held_with"
                                  ? "Investments Held With"
                                  : selectedSet === "liaison_office_access"
                                    ? `${familyOfficeTeamNameText} Access`
                                    : selectedSet === "family_member_access"
                                      ? "Family Member Access"
                                      : selectedSet === "report_type"
                                        ? "Report Since"
                                        : ""}
                            </p>
                          </div>
                          <p className="declaration_text blueTextColor">
                            {selectedSet === "manage_devices" ? (
                              "Remove devices that you sign in from, and check login activity on your profile"
                            ) : selectedSet === "investments_held_with" ? (
                              "Choose any of these options to see your portfolio information"
                            ) : selectedSet === "report_type" ? (
                              "Choose any of these options to see your portfolio information"
                            ) : selectedSet === "family_member_access" ? (
                              <>
                                <h2 className="noti_msg">
                                  Choose which of your family members can{" "}
                                  <span
                                    style={{
                                      fontWeight: 700,
                                      //color: "#7E8899",
                                    }}
                                  >
                                    access and view only their holdings.
                                  </span>{" "}
                                  Based on your selection we will be giving them
                                  access to their account.
                                </h2>
                              </>
                            ) : (
                              ""
                            )}
                          </p>
                        </>
                      )}
                    </div>
                    <div className="set_data_container">
                      {getSettingsTabContent()}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </Observer>
    );
});

export default Settings;
